<template>
    <div
        class="cursor-pointer"
        @contextmenu.prevent="activity.contextMenu($event)"
        @click.prevent="activity.preview()"
    >
        <v-spa-panel
            class="flex items-center space-x-4 bg-white"
        >
            <div
                class="w-10 h-10 bg-gray-200 bg-center bg-cover rounded-full"
                :style="activity.getUser() ? `background-image: url(${activity.getUser().avatar})` : ''"
            ></div>
            <div class="flex-1 leading-tight">
                <span class="block text-sm font-medium text-gray-800">{{ activity.title }}</span>
                <span class="block font-medium" v-if="activity.worksitePhase">{{ activity.worksitePhase.title }}</span>
                <span class="block text-xs text-gray-700" v-if="activity.worksite">
                    {{ activity.worksite.title }}
                    <span
                        class="cursor-pointer"
                        @click.prevent.stop="activity.previewProfitabilityDocument()" 
                        v-if="activity.hasProfitabilityDocument()" 
                        data-tooltip-location="right" 
                        :data-tooltip="$t('time-activity.labels.has_profitability_document')"
                    >
                        <i class="far fa-check-circle"></i>
                    </span>
                </span>
            </div>
            <div>
                <div class="flex items-center space-x-2">
                    <div class="w-[18px]" v-if="activity.status == 'paused'">
                        <!-- This is just a spacer -->
                    </div>
                    <span class="text-gray-600">
                        {{ activity.getStartsAt().format('HH:mm') }} - {{ activity.getEndsAt().format('HH:mm') }}
                    </span>
                </div>
                <div class="flex items-center space-x-2 text-lg">
                    <div v-if="activity.status == 'paused'">
                        <i class="far fa-pause-circle text-orange-600"></i>
                    </div>
                    <live-time-difference
                        container-class-name="w-auto"
                        ref="timeDifference"
                        :activity="activity"
                    ></live-time-difference>
                </div>
            </div>
            <div class="w-[150px] flex items-center justify-end relative">
                <time-activity-actions
                    :activity="activity"
                ></time-activity-actions>
            </div>
        </v-spa-panel>
    </div>
</template>

<script>
    import VueContext from 'vue-context';
    import TimeActivityActions from '@spa/apps/trustup-pro-planning-js/components/TimeActivity/ItemActions';
    import LiveTimeDifference from '@spa/apps/trustup-pro-planning-js/components/TimeActivity/_Partials/LiveTimeDifference';

    export default {
        components: {
            VueContext,
            TimeActivityActions,
            LiveTimeDifference
        },
        props: {
            activity: {
                required: true,
                type: Object
            }
        },
        // watch: {
        //     activity() {
        //         this.$nextTick(() => this.$refs.timeDifference.init());
        //     }
        // }
    }
</script>
